// AUTO-GENERATED CODE, DO NOT EDIT!
/* eslint-disable */

import * as Types from '../../../types';

import gql from 'graphql-tag';
export type AllPropsProposalCardProposalFragment = { __typename?: 'Proposal', attendees: number, currency: string, status: Types.ProposalStatus, baseCostTotal: number, space: { __typename?: 'SelfServeSpace', spaceName?: string | null, spacePhotos?: Array<{ __typename?: 'SelfServeSpacePhoto', url?: string | null }> | null, venue?: { __typename?: 'SelfServeVenue', name?: string | null, nearestTransit?: { __typename?: 'NearestTransit', station?: string | null, distanceKm?: number | null } | null } | null } };

export const AllPropsProposalCardProposalFragmentDoc = gql`
    fragment AllPropsProposalCardProposal on Proposal {
  attendees
  currency
  status
  baseCostTotal
  space {
    spaceName
    spacePhotos {
      url
    }
    venue {
      name
      nearestTransit {
        station
        distanceKm
      }
    }
  }
}
    `;